module.exports = __webpack_public_path__ + "img/img1.44e85350.png";